// 支持 Sentry
// import './sentry'

// 支持 rem
import './flexible'

// 引入 animate.css
import 'animate.css'

// 引入微信支持
import './wechat'

import smoothscroll from 'smoothscroll-polyfill'
// kick off the polyfill!
smoothscroll.polyfill()

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register(`${process.env.BASE_URL}proxy.js`)
// }

import * as components from './components'
import App from './app'
import bizComponents from './biz_components'
import loveDcb from '@/utils/love.js'
import VConsoleView from './vconsole.vue'
import Vue from 'vue'
import { addPortNode } from './port'
import {
  apiCommodityCommodityDetail,
  apiEdgeYcYcVerifyGetInitCode,
  apiEvaluationEvaluateFindVirtualExchangeEvaluateList,
  apiMarketingCouponReceiveOpen,
  apiMerchantBusinessChannelDetail,
  apiOrderOrderDetail,
  apiPageConfigDecorateGetData,
  apiPageConfigDecorateSearch,
  apiPageConfigReceiveStoreCoupon,
  apiSearchMartSearchSearchCommodity,
  apiShoppingCartQuantity,
  apiTradeGeneralTradePreOrder,
} from './api'
import {
  bindEvent,
  copyTextToClipboard,
  debounce,
  GeoCoord,
  inAndroid,
  inIOS,
  loadResource,
  LoadResourceUrlType,
  noop,
  omit,
  placeKitten,
  selectElement,
  selectElementAll,
  wait as waitMs,
} from 'vtils'
import {
  buildOssImageUrl,
  devOrProd,
  eventBus,
  logg,
  noBounce,
  onPageVisibilityChange,
  pTimeout,
  pxToRem,
  removeSensitiveQuery,
  showDialog,
  submit,
  Track,
} from './utils'
import { currentMall } from './mall'
import { dcb } from '@dcb/jssdk'
import { getP } from './api/encrypt'
import { getPageUrl, navigateBack, pageNameMap, router } from './router'
import { globalModel } from './model'
import { h } from '@vue/composition-api'
import { ImagePreview, Popup, Toast } from 'vant'
import { mall } from './mall_jssdk'
import { pageBridge } from './components/page_bridge'
import { pageEnhance } from './components'
// import { Sentry } from './sentry'
import { isAllChannelSameAsCurrent } from './channel'
import { usedVantComponents } from './vant'
import { VueMasonryPlugin } from 'vue-masonry'
import { wechat } from './wechat'

// 暂时兼容新埋点 JSSDK 全局引入了一个新 @dcb/jssdk 实例的问题
window.dcb = dcb

Vue.use(bizComponents, {
  // 转换像素，如果需要做自适应，则必传
  transformPx: v => `${pxToRem(v)}rem`,

  // 返回上一页
  back: () => navigateBack(),

  // 接口实现
  api: {
    // 获取组件数据
    // 传参和返回必须和该接口一致：
    // https://yapi.gogpay.cn/project/1011/interface/api/217030
    getComponentData: payload =>
      !payload.useCdn
        ? apiPageConfigDecorateGetData(payload)
        : payload.pageIndex === 1
        ? apiPageConfigDecorateGetData(payload, {
            useCdnData: `https://dcb-resource.${devOrProd(
              'duotest',
              'gogpay',
            )}.cn/mall-platform/dcb-mall/decorate/${
              payload.innerId || payload.id
            }.json`,
          })
        : {
            list: [],
          },

    // 搜索资源
    // 传参和返回必须和该接口一致：
    // https://yapi.gogpay.cn/project/1011/interface/api/217038
    // 入参新增了 type 属性，为 store 时表示搜索店铺下商品数据，可能需自行转换相关数据
    searchResource: payload =>
      payload.type === 'store'
        ? apiSearchMartSearchSearchCommodity({
            searchWord: payload.keyword,
            pageIndex: payload.pageIndex,
            pageSize: payload.pageSize,
            refMartId: '',
            refMerchantId: payload.id,
            categoryIds: [],
            categoryParams: {},
            inStockFlag: false,
            promoteFlag: false,
            minPrice: 0,
            maxPrice: 99999,
            sceneId: '55f9be7e73c04949bfa7a0c850d33924',
            sortType:
              payload.sortType === 'sales' && payload.direction === 'asc'
                ? '00'
                : payload.sortType === 'sales' && payload.direction === 'desc'
                ? '01'
                : payload.sortType === 'price' && payload.direction === 'asc'
                ? '03'
                : payload.sortType === 'sales' && payload.direction === 'desc'
                ? '04'
                : '02',
          }).then(res => ({
            ...res,
            list: res.list.map(item => ({
              id: item.commodityResourceId,
              title: item.commodityTitle,
              subTitle: '',
              icon: item.coverPic,
              amt: item.dashPrice,
              discountAmt: item.price,
              sales: item.saleNum,
              tags: [],
              resType: '01',
            })),
          }))
        : apiPageConfigDecorateSearch(payload),

    // 领券接口
    receiveCoupon: payload =>
      payload.isStore
        ? apiPageConfigReceiveStoreCoupon({
            id: payload.couponActId,
          })
        : apiMarketingCouponReceiveOpen(payload, {
            errorMessageMap: {
              '没领到哦，你的单张券已领取达到上限': [1001, 1007, 1008],
              '活动已结束，无法继续领取': [1003, 1004, 1005],
              '领取失败，当前不在领取时段内': [1009],
              '领取失败，不符合领券要求': [1012],
            },
          }),
    // 商品详情接口
    getCommodityData: payload => apiCommodityCommodityDetail(payload),
    // 客户端获取85兑换券首页商品评价接口
    getVirtualExchangeEvaluateList: payload =>
      apiEvaluationEvaluateFindVirtualExchangeEvaluateList(payload),

    // 商品预下单
    generalTradePreOrder: payload => apiTradeGeneralTradePreOrder(payload),

    // 获取购物车数量
    getCartCount: () => apiShoppingCartQuantity().then(res => res.quantity),
  },

  // 点击资源操作
  handleResourceClick: (res, trackFrom) => {
    if (res.targetUrl) {
      Vue.prototype.$handleResourceClick(res, trackFrom)
    }
  },
})

Vue.prototype.$mall = mall

window.getCurrentPageTestUrl = () => {
  const url = getPageUrl(
    router.currentRoute.name,
    omit(router.currentRoute.query, [
      'rf',
      'isDebug',
      'isAuth',
      'isLogin',
      'isFull',
      'isWechatDebug',
    ]),
    'test',
  )
  copyTextToClipboard(url)
  console.log(url)
}

window.getCurrentPageProdUrl = () => {
  const url = getPageUrl(
    router.currentRoute.name,
    omit(router.currentRoute.query, [
      'rf',
      'isDebug',
      'isAuth',
      'isLogin',
      'isFull',
      'isWechatDebug',
    ]),
    'prod',
  )
  copyTextToClipboard(url)
  console.log(url)
}

let wait = Promise.resolve()

// 按需开启 VConsole
if (
  globalModel.state.isDebug &&
  (globalModel.state.inAlipay ||
    globalModel.state.inWeapp ||
    inAndroid() ||
    inIOS()) &&
  !window.VConsole
) {
  wait = import('vconsole').then(({ default: VConsole }) => {
    const dcbPlugin = new VConsole.VConsolePlugin('dcb', '多彩宝')
    dcbPlugin.on('renderTab', function (callback) {
      addPortNode(
        h(VConsoleView, {
          attrs: {
            id: '__dcb_vconsole__',
          },
          on: {
            ready() {
              const html = document.querySelector('#__dcb_vconsole__')
              callback(html)
            },
          },
        }),
      )
    })
    const vConsole = new VConsole({
      onReady: function () {
        const vconsole = selectElement('div#__vconsole')
        document.body.appendChild(vconsole)
        setTimeout(() => {
          ;[
            ...selectElementAll('.vc-switch'),
            ...selectElementAll('.vc-tool'),
            ...selectElementAll('.vc-tab'),
            ...selectElementAll('.vc-toptab'),
            ...selectElementAll('.vc-content'),
          ].forEach(el => {
            el.setAttribute(Vue.prototype.$tv.itemAttrname, '')
            el.classList.add('no-focused-style')
          })

          bindEvent(selectElement('.vc-content'))('left', () => {
            Vue.prototype.$tv.goTo(selectElement('.vc-content'))
            Vue.prototype.$tv.scrollUp(selectElement('.vc-content'))
          })
          bindEvent(selectElement('.vc-content'))('right', () => {
            Vue.prototype.$tv.goTo(selectElement('.vc-content'))
            Vue.prototype.$tv.scrollDown(selectElement('.vc-content'))
          })
          this['compInstance'].$on('show', e => {
            if (e.detail.show) {
              Vue.prototype.$tv.setLimitingEl(selectElement('.vc-panel'))
            } else {
              Vue.prototype.$tv.resetLimitingEl()
            }
          })
        }, 60)
      },
    })
    vConsole.addPlugin(dcbPlugin)
  })
}

// 在盐城 APP 内
if (globalModel.state.inYancheng) {
  wait = wait.then(async () => {
    await loadResource({
      type: LoadResourceUrlType.js,
      path: 'https://open.myyancheng.com.cn/lib/jpasc-0.4.0.js',
    })
    const { initCode } = await apiEdgeYcYcVerifyGetInitCode()
    await new Promise(resolve => {
      sc.config({
        debug: false, //开发时建议把调试模式开启
        appId: '2551be7f07364a71b6797e8ab0b25fdd', //从盐城开放平台申请到的appId
        initCode: initCode, //从业务方自己后台请求到initCode, getInitCode.do不能由H5直接向开放平台获取，因为开放平台对业务方后台有白名单校验，直接由H5请求getInitCode.do的话，会发生错误
      })
      sc.ready(resolve)
      sc.error(resolve)
    })
  })
}

wait.then(async () => {
  // 配置 JSSDK
  dcb
    .config({
      appId: '100001',
      appSecret: '088f3067e5d1497e897eb732cc30fc28',
      debug: globalModel.state.isDebug,
      track: {
        sdkUrl: `https://cdn-resource.gogpay.cn/jssdk/countlyVueUtil.5.3.7.js?noDefaultClickListener=true&noInitLoadEventPush=true&env=prod`,
      },
    })
    .then(() => {
      // dcb.getAppInfo()
      // .then(appInfo => {
      //   // 设置 Sentry 多彩宝客户端版本、网络类型
      //   // Sentry.setTags({
      //   //   dcb: `${appInfo.release_code}<${appInfo.version_code}>`,
      //   //   network: String(appInfo.net_type || 'NONE').toUpperCase(),
      //   // })
      // })
      dcb.closeSplashScreen()
      dcb.hideNavigationBar()
      dcb.setStatusBarColor('#000000')
      // dcb.getUserInfo()
      // .then(user => {
      //   // 设置 Sentry 用户
      //   // Sentry.setUser({
      //   //   id: user.phoneNumber,
      //   //   username: user.nickname,
      //   //   p: getP(),
      //   // })
      // })
    })

  // TV 逻辑
  if (globalModel.state.isTV) {
    await import(/* webpackChunkName: "tv" */ './views/tv/init')
  }

  const env = dcb.getEnvSync()
  // 埋点项目进入
  Track.pushEvent({
    name: '进入项目',
    newId: 'jin_ru_xiang_mu',
    extra: {
      track_code: '25a5fe38ab244726812d7cffb5d19f36',
    },
  })

  // 仅生成环境：非多彩宝、微信环境跳转下载APP
  // if (
  //   process.env.NODE_ENV === 'production' &&
  //   process.env.VUE_APP_RUN_ENV === 'production'
  // ) {
  //   if (
  //     !location.href.includes('/admin/') &&
  //     !env.dcb &&
  //     !env.wechat &&
  //     !globalModel.state.isDebug &&
  //     !globalModel.state.isWhitePage
  //   ) {
  //     location.href = 'https://h5gateway.gogpay.cn/appRS/index'
  //     return
  //   }
  // }

  // 如果不在多彩宝中，链接存在敏感参数，去除并重载页面
  // if (
  //   !env.dcb &&
  //   // 盐城安卓客户端 location.reload() 后不显示
  //   !globalModel.state.inYancheng
  // ) {
  //   if (hasSensitiveQuery(location.href)) {
  //     location.replace(removeSensitiveQuery(location.href))
  //     location.reload()
  //     return
  //   }
  // }

  // 让 iOS 支持 :active
  document.body.addEventListener('touchstart', noop)

  globalModel.update({
    env: env,
  })

  // 劫持多彩宝 JSSDK 实现些需求
  dcb.onInvokeMethod('share', payload => {
    // 去除分享链接上的敏感参数
    payload.url = removeSensitiveQuery(payload.url)

    if (globalModel.state.inLove) {
      return loveDcb.share({
        ...payload,
        provider: 'weixin',
        scene: 'WXSceneSession',
        type: 0,
        title: payload.title,
        summary: payload.desc,
        href: payload.url,
        imageUrl: payload.cover,
      })
    }

    // 非多彩宝分享
    if (!env.dcb) {
      wechat.updateShareData({
        title: payload.title,
        desc: payload.desc,
        imgUrl: payload.cover,
        link: payload.url,
      })
      globalModel.update({
        shareGuideVisible: true,
        shareGuideText: payload.guide || '点击右上角分享给好友~',
      })
      return true
    }
  })
  dcb.onInvokeMethod('navigateTo', payload => {
    if (globalModel.state.isEmbed) return
    if (!payload.url) {
      return false
    }

    // 内部链接处理
    if (payload.url.includes('/duoduo-mall/')) {
      if (
        !payload.url.includes('/bridge/') &&
        (process.env.VUE_APP_RUN_ENV === 'development'
          ? true
          : isAllChannelSameAsCurrent(payload.url))
      ) {
        router.push(payload.url.split('#')[1])
        return true
      }
      // 多彩宝下在 # 前加 ? 号 app 处理有问题
      if (!env.dcb) {
        payload.url = payload.url.replace('#', `?ts=${Date.now()}#`)
        // if(globalModel.state.inLove){
        //   loveDcb.navigateTo({ url: payload.url })
        // }
      }
    }

    if (!env.dcb) {
      // 注入 P 参数和 openid
      const url = payload.url.replace(
        'isLogin=true',
        `p=${encodeURIComponent(getP())}&openId=${encodeURIComponent(
          globalModel.state.openid,
        )}`,
      )
      if (globalModel.state.inYancheng) {
        sc.openNewWebView({
          url: url,
        })
        return true
      }

      if (globalModel.state.inLove) {
        loveDcb.navigateTo({ url })
        return true
      }
      payload.url = url
    }
  })
  dcb.onInvokeMethod('requestPayment', payload => {
    // 翼支付
    if (+payload.params.payType === 15) {
      return new Promise((resolve, reject) => {
        const url = payload.params.thirdParams.jumpUrl
        dcb.navigateTo({
          url: url,
        })
        const off = onPageVisibilityChange(async visible => {
          if (visible) {
            off()
            await waitMs(2000)
            const orderDetail = await apiOrderOrderDetail({
              orderNo: payload.params.orders[0].orderId,
            })
            if (orderDetail.status === 0 || orderDetail.status === 901) {
              reject(new Error('支付失败'))
            } else {
              resolve()
            }
          }
        })
      })
    }
    if (+payload.params.payType === -1) {
      return new Promise(() => {
        new Promise((resolve, reject) => {
          if (payload.params.thirdParams.title) {
            showDialog({
              title: '提示',
              message: payload.params.thirdParams.title,
              cancelText: '取消',
              confirmText: '确认',
              onConfirm: resolve,
              onCancel: reject,
            })
          } else {
            resolve()
          }
        }).then(() => {
          dcb.navigateTo({
            url: payload.params.thirdParams.url,
          })
        })
        // 不 resolve 挂起，让用户返回页面后自行继续点击支付
      })
    }
    // 0 元付
    if (+payload.params.payType === 13) {
      return { success: true }
    }
    // 微信外 H5 支付
    if (+payload.params.payType === 6) {
      return new Promise((resolve, reject) => {
        let url = payload.params.thirdParams.targetUrl
        console.log('targetUrl', url)
        if (!url.includes('/mall/bridge/wxpay/')) {
          url = getPageUrl(
            'BridgeWxpay',
            {
              url: url,
            },
            {
              env: devOrProd('test', 'prod'),
            },
          )
        }

        dcb.navigateTo({
          url: url,
        })
        const off = onPageVisibilityChange(async visible => {
          if (visible) {
            off()
            await waitMs(2000)
            const orderDetail = await apiOrderOrderDetail({
              orderNo: payload.params.orders[0].orderId,
            })
            if (orderDetail.status === 0 || orderDetail.status === 901) {
              reject(new Error('支付失败'))
            } else {
              resolve()
            }
          }
        })
      })
    }
    // 小程序内支付
    if (globalModel.state.inWeapp) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        wx.miniProgram.navigateTo({
          url: `/pages/pay/pay?payClose=${!!payload.params
            .isVirtualPay}&data=${encodeURIComponent(
            JSON.stringify(payload.params.thirdParams),
          )}`,
        })
        const off = onPageVisibilityChange(async visible => {
          if (visible) {
            off()
            await waitMs(2000)
            const orderDetail = await apiOrderOrderDetail({
              orderNo: payload.params.orders[0].orderId,
            })
            if (orderDetail.status === 0 || orderDetail.status === 901) {
              reject(new Error('支付失败'))
            } else {
              resolve()
            }
          }
        })
      })
    }
    // 支付宝小程序内
    if (globalModel.state.inAlipay) {
      return (
        typeof my === 'undefined'
          ? loadResource('https://appx/web-view.min.js')
          : Promise.resolve()
      ).then(
        () =>
          new Promise((resolve, reject) => {
            // eslint-disable-next-line no-undef
            my.navigateTo({
              url: `/pages/pay/pay?data=${encodeURIComponent(
                JSON.stringify(payload.params.thirdParams),
              )}`,
            })
            const off = onPageVisibilityChange(async visible => {
              if (visible) {
                off()
                await waitMs(2000)
                const orderDetail = await apiOrderOrderDetail({
                  orderNo: payload.params.orders[0].orderId,
                })
                if (orderDetail.status === 0 || orderDetail.status === 901) {
                  reject(new Error('支付失败'))
                } else {
                  resolve()
                }
              }
            })
          }),
      )
    }
    // 微信内支付
    if (globalModel.state.inWechatWebView) {
      return wechat.requestPayment(payload.params.thirdParams)
    }

    // 爱情计算器内支付
    if (globalModel.state.inLove) {
      payload.params.paySource = '13'
      return loveDcb.requestPayment(payload)
    }
  })
  dcb.onInvokeMethod('closeWindow', () => {
    if (globalModel.state.inYancheng) {
      sc.close()
    }
    if (globalModel.state.inLove) {
      loveDcb.closeWindow()
    }
  })
  dcb.onInvokeMethod('makePhoneCall', payload => {
    if (payload.phoneNumber) {
      const phoneNumbers = payload.phoneNumber
        .replace(/；/g, ';')
        .split(';')
        .filter(Boolean)
      if (phoneNumbers.length > 1) {
        const destroy = addPortNode(
          h({
            data: () => ({
              visible: false,
            }),

            mounted() {
              // @ts-ignore
              this.visible = true
            },

            render() {
              return h(
                Popup,
                {
                  style: {
                    width: `${pxToRem(311)}rem`,
                    borderRadius: `${pxToRem(8)}rem`,
                    border: '1px solid #979797',
                    padding: `${pxToRem(20)}rem`,
                  },
                  props: {
                    value: this.visible,
                  },
                  on: {
                    input: visible => {
                      if (!visible) {
                        // @ts-ignore
                        this.visible = false
                        setTimeout(destroy, 4000)
                      }
                    },
                    select: item => item.onClick(),
                  },
                },
                [
                  h('div', [
                    h(
                      'div',
                      {
                        style: {
                          fontSize: `${pxToRem(18)}rem`,
                          fontWeight: `bold`,
                          color: '#333',
                        },
                      },
                      ['拨打电话'],
                    ),
                    ...phoneNumbers.map(phoneNumber =>
                      h(
                        'div',
                        {
                          key: phoneNumber,
                          style: {
                            marginTop: `${pxToRem(16)}rem`,
                            fontSize: `${pxToRem(16)}rem`,
                            color: '#333',
                          },
                          on: {
                            click: () => {
                              dcb.makePhoneCall({
                                phoneNumber: phoneNumber,
                              })
                            },
                          },
                        },
                        [phoneNumber],
                      ),
                    ),
                  ]),
                ],
              )
            },
          }),
        )
        return true
      }
    }
  })
  dcb.onInvokeMethod('getLocation', () => {
    if (globalModel.state.inWechatWebView) {
      return pTimeout(
        wechat
          .invoke('getLocation', {
            type: 'wgs84',
          })
          .then(res => {
            logg('获取微信经纬度结果', res)
            const { longitude, latitude } = GeoCoord.WGS84ToBD09({
              longitude: res.longitude,
              latitude: res.latitude,
            })
            logg('微信经纬度转换成多彩宝经纬度结果', {
              longitude,
              latitude,
            })
            return {
              longitude: longitude,
              latitude: latitude,
            }
          }),
        3000,
      )
    } else if (globalModel.state.inYancheng) {
      return new Promise((resolve, reject) => {
        sc.gps(res => {
          if (res.code === 0) {
            const { longitude, latitude } = GeoCoord.GCJ02ToBD09({
              longitude: res.data.longitude,
              latitude: res.data.latitude,
            })
            resolve({
              longitude: longitude,
              latitude: latitude,
            })
          } else {
            reject()
          }
        })
      })
    }
  })
  dcb.onInvokeMethod('share', payload => {
    if (payload) {
      // 暂只能分享微信
      payload.channel = ['wechat', 'wechat-timeline']
    }
  })

  // 中国红逻辑
  // 不应放在上面，会导致调不到出问题
  // if (globalModel.state.inRedChina) {
  //   window.dcb = rch
  //   rch.config({})
  //   dcb.onInvoke((method, payload) => rch[method](payload))
  // }

  // 按需引入 vant
  Object.keys(usedVantComponents).forEach(name => {
    const Component =
      usedVantComponents[name].Component || usedVantComponents[name]
    if (Component) {
      Vue.use(Component)
    }
  })

  // 引入自定义组件
  Object.keys(components).forEach(name => {
    Vue.component(name, components[name])
  })

  // 瀑布流
  Vue.use(VueMasonryPlugin)

  // 为 $style 设置别名 _
  Vue.mixin({
    computed: {
      _() {
        return {
          ...this.$style,
          // 支持 vant 内置样式
          // https://vant-contrib.gitee.io/vant/#/zh-CN/style
          _ellipsis: 'van-ellipsis',
          _ellipsisFlex: 'van-multi-ellipsis--l1',
          _ellipsis2: 'van-multi-ellipsis--l2',
          _ellipsis3: 'van-multi-ellipsis--l3',
          _hairline: 'van-hairline--surround',
          _hairlineTop: 'van-hairline--top',
          _hairlineBottom: 'van-hairline--bottom',
          _hairlineRight: 'van-hairline--right',
          _hairlineTopBottom: 'van-hairline--top-bottom',
          _fade: 'van-fade',
          _slideUp: 'van-slide-up',
          _slideDown: 'van-slide-down',
          _slideLeft: 'van-slide-left',
          _slideRight: 'van-slide-right',
        }
      },
    },
  })

  // 实现占位图函数
  Vue.prototype.$place = placeKitten

  // 实现 OSS 图片处理
  Vue.prototype.$tiny = buildOssImageUrl

  // 实现事件巴士
  Vue.prototype.$eventBus = eventBus

  // 多彩宝 JSSDK
  Vue.prototype.$dcb = dcb

  // 禁用 iOS 橡皮筋效果
  noBounce()

  // 软键盘行为兼容
  Vue.directive('fix-keyboard', {
    bind(el) {
      const input =
        el.tagName === 'INPUT' || el.tagName === 'TEXTAREA'
          ? el
          : el.querySelector('input, textarea')
      if (input) {
        const offFocus = bindEvent(input)(
          'focus',
          () => {
            // fix: 软键盘出现时将输入框滚动进入视图
            input.scrollIntoView()
          },
          false,
        )
        const offBlur = bindEvent(input)(
          'blur',
          () => {
            // fix: iOS 软键盘撑起页面，软键盘消失页面却不会复位
            document.activeElement.scrollIntoView()
          },
          false,
        )
        input.__keyboard_dispose__ = () => {
          offFocus()
          offBlur()
        }
      }
    },
    unbind(el) {
      const input = el.querySelector('input, textarea')
      if (input) {
        input?.__keyboard_dispose__?.()
      }
    },
  })

  // 一屏内隐藏
  Vue.directive('hide-when-one-screen', {
    bind(el) {
      el.style.visibility = 'hidden'
      el.style.pointerEvents = 'none'
      el.__hide_when_one_screen_off__ = pageBridge.on(
        'scroll',
        debounce(
          ({ scrollTop }) => {
            if (scrollTop < window.innerHeight) {
              el.style.visibility = 'hidden'
              el.style.pointerEvents = 'none'
            } else {
              el.style.visibility = 'visible'
              el.style.pointerEvents = 'auto'
            }
          },
          600,
          {
            trailing: true,
          },
        ),
      )
    },
    unbind(el) {
      el.__hide_when_one_screen_off__?.()
    },
  })

  // 仅多彩宝可访问
  Vue.directive('dcb-only', {
    inserted(el) {
      el.__dcb_only_dispose__ = bindEvent(el)(
        'click',
        e => {
          if (!dcb.getEnvSync().dcb) {
            e.preventDefault()
            e.stopPropagation()
            Toast('请用多彩宝打开')
          }
        },
        {
          // 必须使用捕获模式以在其他事件触发前处理（比如其他事件触发了页面跳转，就会导致问题）
          capture: true,
          // 使用被动模式告诉浏览器这不会产生阻塞行为
          passive: true,
        },
      )
    },
    unbind(el) {
      el.__dcb_only_dispose__?.()
      delete el.__dcb_only_dispose__
    },
  })

  // 图片点击预览
  Vue.directive('image-preview', {
    inserted(el) {
      el.__image_preview_dispose__ = bindEvent(el)(
        'click',
        e => {
          if (e.target.tagName === 'IMG') {
            ImagePreview({
              images: [e.target.src],
            })
          }
        },
        {
          // 使用被动模式告诉浏览器这不会产生阻塞行为
          passive: true,
        },
      )
    },
    unbind(el) {
      el.__image_preview_dispose__?.()
      delete el.__image_preview_dispose__
    },
  })

  // 空白时隐藏
  function hideWhenEmpty(
    /** @type {HTMLDivElement} */
    el,
  ) {
    if (!('__display__' in el)) {
      el.__display__ = window.getComputedStyle(el).display
    }
    Vue.nextTick(() => {
      if (!el.innerText.trim()) {
        el.style.display = 'none'
      } else {
        el.style.display = el.__display__
      }
    })
  }
  Vue.directive('hide-when-empty', {
    inserted: hideWhenEmpty,
    update: hideWhenEmpty,
    componentUpdated: hideWhenEmpty,
  })

  // 是否是广告资源位
  Vue.prototype.$isAdResource = item => {
    return Boolean(
      item &&
        // 不是商品的都视为广告
        (Number(item.resType) !== 1 ||
          (item.remark &&
            item.remark.some(
              tag =>
                tag.name === 'dcb-mall-ad' ||
                (tag.name === 'resource-type' && tag.value === 'advertising'),
            ))),
    )
  }

  // 从资源位导出标签
  Vue.prototype.$extractTagsFromResource = item => {
    return (item?.remark || [])
      .map(tag =>
        tag.name === 'resource-type' ||
        tag.name === 'dcb-mall-ad' ||
        tag.name === 'is_need_confirm' ||
        tag.name === 'confirm_tips'
          ? ''
          : tag.value,
      )
      .filter(Boolean)
  }

  // 点击资源位条目
  Vue.prototype.$handleResourceClick = (item, trackFrom) => {
    if (trackFrom && item.targetUrl) {
      item.targetUrl = `${
        item.targetUrl + (item.targetUrl.includes('?') ? '&' : '?')
      }track_from=${encodeURIComponent(trackFrom)}`
    }

    // 跳转确认
    if (
      (item?.remark || []).some(
        tag => tag.name === 'is_need_confirm' && !!tag.value,
      )
    ) {
      const confirmTips = item.remark.find(
        tag => tag.name === 'confirm_tips',
      ).value
      if (confirmTips) {
        globalModel.update({
          leaveDialogVisible: true,
          leaveDialogMessage: confirmTips,
          leaveDialogUrl: item.targetUrl,
        })
        return
      }
    }

    if (item.targetUrl) {
      dcb.navigateTo({
        url: item.targetUrl,
      })
      return
    }
  }

  Vue.prototype.$devOrProd = devOrProd

  Vue.config.productionTip = false
  Vue.config.devtools = true

  router.beforeEach((to, from, next) => {
    // 存储上一页
    globalModel.update({
      lastPageName: from.name,
    })

    next()
  })

  // 埋点
  Vue.use(Track, {
    appid: globalModel.state.isCouponMall
      ? 'coupon-mall'
      : currentMall.mall_app_name,
    prefix: `${
      globalModel.state.isCouponMall ? '消费券商城' : currentMall.mall_name
    }-`,
  })

  Vue.mixin(pageEnhance())

  submit(async () => {
    const orderPathMap = {
      mall: pageNameMap.OrderIndex,
      writeOff: pageNameMap.BookOrderIndex,
      deliver: pageNameMap.InstantDeliveryOrderIndex,
      group: pageNameMap.GroupBuyingOrderIndex,
    }
    // $.start()
    const res = await apiMerchantBusinessChannelDetail(
      {},
      {
        noErrorToast: true,
        noP: true,
      },
    ).catch(() => ({
      isShowTab: true,
      jumpRoute: '',
      isShowDcbResource: 1,
      showOrderClassify: [
        {
          label: '多多商城订单',
          value: 'mall',
        },
        {
          label: '周边游订单',
          value: 'writeOff',
        },
        {
          label: '同城配送订单',
          value: 'deliver',
        },
        {
          label: '拼团订单',
          value: 'group',
        },
      ],
    }))
    globalModel.update({
      channelIsShowTab: res.isShowTab,
      channelJumpRoute: res.jumpRoute,
      channelIsShowDcbResource: res.isShowDcbResource,
      channelShowOrderClassify: res.showOrderClassify.map(item => ({
        ...item,
        pageName: orderPathMap[item.value],
      })),
    })
    new Vue({
      router,
      // 埋点
      mixins: [Track.App],
      render: h => h(App),
    }).$mount('#app')
  })
})
